/* eslint-disable import/no-unresolved */
import React, { useState, useEffect, useRef } from 'react';
import FlexGrid from '@tds/core-flex-grid';
import lodash from 'lodash';
import PropTypes from 'prop-types';
import { v4 as uuidv4 } from 'uuid';

import AddForm from './addForm';
import AddedItemsList from './addedItemsList';
import {
  fieldOfficePhoneType,
  fieldOfficePhoneCallingFeatures,
  fieldOfficePhoneLongDistanceAddons,
  fieldOfficeLineDesignation,
  fieldOfficePhoneSetup,
  officePhoneRowTypes,
  officePhoneFieldValues,
  fieldOfficeRatePlan,
  fieldOfficePhoneregularOffer,
  fieldOfficePhoneTerm,
  fieldOfficePhoneContractBuyout,
  fieldOfficePhoneTwoMonthsFree,
  fieldOfficePhonelimitedTimeOffer,
  fieldOfficePhonePricingAndOffers,
  fieldForbearance,
  valueTariffed,
  phoneNumber,
  tollFree
} from '../../utils/constant';
import {
  longDistanceAddOns,
  officePhoneForbornePricing as pricing,
  officePhoneNonForbornePricing as pricingNonForborne
} from '../businessLogic/rates';
import { useTranslationsContext } from '../../context/TranslationsContext';
import { processContractBuyoutFields } from './processFields';
import { getLocale } from '../../misc';
import EN from '../../../EN.json'
import FR from '../../../FR.json';

const locale = getLocale();

const {
   contentfulValues: {
    officePhone: {
      opBasic,
      yes,
      tollFreePrice
    },
   }
  
} = locale === 'en-US' ? EN : FR;

const OfficePhone = ({
  isOrderOfficePhone,
  fields,
  setFormFields,
  formFields,
  setIsFormTouched,
  orderData,
  isEditing,
  setDueMonthly,
  dueMonthly,
  setOfficePhoneRequired
}) => {

  const [networkType, setNetworkType] = useState({});
  const translations = useTranslationsContext();
  const {
    contentfulValues: {
      officePhone: {
        fieldRequired: fieldRequiredText,
        internetProducts: { fiber, copper }
      }
    }
  } = translations;
  const ref = useRef();
  const typeField = fields.find(
    field => field.fields.name === fieldOfficePhoneType
  );
  const callingFeatureField = fields.find(
    field => field.fields.name === fieldOfficePhoneCallingFeatures
  );
  const longDistanceAddonField = fields.find(
    field => field.fields.name === fieldOfficePhoneLongDistanceAddons
  );
  const regularOfferField = fields.find(
    field => field.fields.name === fieldOfficePhoneregularOffer
  );

  const typeFieldOptions = typeField.fields.options;
  const callingFeaturesFieldOptions = callingFeatureField.fields.options;
  const longDistanceAddonsFieldOptions = longDistanceAddonField.fields.options;
  const regularOfferFieldOptions = regularOfferField.fields.options;
  const [, ...restFields] = lodash.cloneDeep(fields);
  restFields[9].fields.hidden = true;
  restFields[10].fields.hidden = true;
  restFields[11].fields.readonly = true;
  restFields[7].fields.hidden = true;
  restFields[8].fields.hidden = true;
  if (isOrderOfficePhone) {
    restFields[14].fields.hidden = true;
    restFields[15].fields.hidden = true;
    restFields[16].fields.hidden = true;
    restFields[17].fields.hidden = true;
    // restFields[18].fields.hidden = true;
  }

  const selectedProductsValue =
    (formFields.productSelection && formFields.productSelection.value) ||
    orderData.productSelection;

  if (
    !selectedProductsValue.includes(fiber) &&
    !selectedProductsValue.includes(copper)
  ) {
    restFields[11].fields.disabled = true;
    restFields[11].fields.hidden = true;
  }

  const fieldPricingAndOffersNote = lodash.cloneDeep(
    restFields[12].fields.note
  );
  delete restFields[12].fields.note;

  const initialForm = [
    {
      key: uuidv4(),
      fields: [
        {
          ...typeField,
          fields: {
            ...typeField.fields,
            options: [typeFieldOptions[0], typeFieldOptions[1]]
          }
        },
        ...lodash.cloneDeep(restFields)
      ],
      ovLines: []
    }
  ];

  const [formTouched, setFormTouched] = useState(false);
  const [addedItems, setAddedItems] = useState([]);
  const [fieldRows, setFieldRows] = useState(initialForm);
  const [phoneSetupNew, setPhoneSetupNew] = useState('');
  const [phoneCountNumber, setPhoneCountNumber] = useState('');

  useEffect(() => {
    const dataField = isEditing ? orderData : formFields;
    if (dataField.officePhoneData && dataField.officePhoneData.length) {
      setOfficePhoneRequired(false);
      setAddedItems([...dataField.officePhoneData]);
      setTimeout(() => {
        setIsFormTouched(true);
      }, 1);
    } else {
      setOfficePhoneRequired(true);
    }
  }, []);
  const [opFields] = fieldRows;
  const forbearanceFieldValue =
    (opFields.fields[7].fields && opFields.fields[7].fields.value) ||
    orderData.forbearance;
  if (forbearanceFieldValue === officePhoneFieldValues.forbearance.forborne) {
    restFields[12].fields.hidden = true;
  } else if (
    forbearanceFieldValue === officePhoneFieldValues.forbearance.nonForborne
  ) {
    restFields[8].fields.hidden = true;
    restFields[9].fields.hidden = true;
  }
  const onFieldChange = (
    { target: { value, name } },
    paramField,
    rowType,
    paramLineFields
  ) => {
    let lineFields = paramLineFields;
    const field = paramField;

    field.fields.value = value;
    if (value) {
      field.fields.error = null;
    }

    const [fieldRow] = fieldRows;
    const rowFields = fieldRow.fields;
    if (name.includes(fieldOfficePhoneType)) {
      if (value === officePhoneFieldValues.type.multiLine) {
        const [, ...otherFields] = lodash.cloneDeep(restFields);
        delete otherFields[10].fields.note;
        otherFields[4].fields.options = rowFields[6].fields.options;
        const typeFieldCopy = lodash.cloneDeep(typeField);
        const copyOfLineDesignation = rowFields[3];
        const planFieldCopy = rowFields[1];
        const newFields = [
          {
            ...typeFieldCopy,
            fields: {
              ...typeFieldCopy.fields,
              disabled: true,
              options: [typeFieldOptions[2]],
              value: officePhoneFieldValues.type.ovLine
            }
          },
          planFieldCopy,
          ...otherFields
        ];
        const [
          ,
          ,
          ,
          rowFieldsDesignation,
          ,
          rowFieldsCallingFeatures
        ] = rowFields;
        newFields[3] = copyOfLineDesignation;
        if (
          planFieldCopy.fields.value === officePhoneFieldValues.ratePlan.opBasic
        ) {
          newFields[3] = rowFieldsDesignation; // copy line designation form above row
          newFields[5] = rowFieldsCallingFeatures; // copy calling features fromo above row
        }
        newFields.forEach((data, index) => {
          if (data.fields.name === tollFree) {
            newFields[index].fields.hidden = true;
          }
        });
        fieldRow.ovLines.push({
          key: uuidv4(),
          fields: newFields
        });
      } else if (rowType === officePhoneRowTypes.mainRow) {
        fieldRows[0].ovLines = [];
      }
    }
    else if (name.includes(fieldForbearance)) {
      if (value === valueTariffed) {
        lineFields[13].fields.hidden = false;
        lineFields[8].fields.hidden = true;
        lineFields[9].fields.hidden = true;
      } else {
        lineFields[13].fields.hidden = true;
        lineFields[8].fields.hidden = false;
        lineFields[9].fields.hidden = false;
      }
    }
    
    else if (name.includes(fieldOfficeRatePlan)) {
      if ([officePhoneFieldValues.ratePlan.opBasic , officePhoneFieldValues.ratePlan.opUtility].includes(value)) {
        rowFields[5].fields.options = callingFeaturesFieldOptions.slice(0, -1);
        rowFields[6].fields.options = longDistanceAddonsFieldOptions;
      } 
      else {
        if (value === officePhoneFieldValues.ratePlan.op) {
          rowFields[6].fields.options = [
            longDistanceAddonsFieldOptions[1],
            longDistanceAddonsFieldOptions[2]
          ];
        } 
        else {
          rowFields[6].fields.options = [longDistanceAddonsFieldOptions[2]];
        }
          if (value === officePhoneFieldValues.ratePlan.op) {
            rowFields[6].fields.options = longDistanceAddonsFieldOptions.slice(1);
          } else if (value === officePhoneFieldValues.ratePlan.opPlus) {
            rowFields[6].fields.options = [longDistanceAddonsFieldOptions[1]];
          }
        
        // rowFields[6].fields.options = callingFeaturesFieldOptions.slice(-1);
      }
      fieldRow.ovLines.forEach(ovLineParam => {
        const ovLine = ovLineParam;
        const [, , , , , callingFeaturesFld] = rowFields;
        ovLine.fields[5] = callingFeaturesFld;
        ovLine.fields[6].fields.options = rowFields[6].fields.options;
      });
    } else if (name.includes(fieldOfficePhoneSetup)) {
      if (value === officePhoneFieldValues.setup.new) {
        lineFields[4].fields.value = '';
        lineFields[4].fields.disabled = true;
        lineFields[4].fields.error = '';
        setPhoneSetupNew('new');
      } else {
        lineFields[4].fields.disabled = false;
        setPhoneSetupNew('');
      }
    } else if (name.includes(phoneNumber)) {
      lineFields[4].fields.value = +lineFields[4].fields.value;
      if (value.length !== 10) {
        lineFields[4].fields.error = "Must be 10 digits"
        setPhoneCountNumber('lessThan10');
      } else setPhoneCountNumber('');
    } else if (name.includes(fieldOfficePhoneTerm)) {
      if (value === officePhoneFieldValues.term.monthToMonth) {
        lineFields[9].fields.options = [...regularOfferFieldOptions];
        lineFields[12].fields.hidden = false;
      } else if (value === officePhoneFieldValues.term.threeYearTerm) {
        lineFields[9].fields.options = [regularOfferFieldOptions[0]];
        lineFields[12].fields.hidden = true;
      }
    } else if (name.includes(fieldOfficePhoneregularOffer)) {
        if (
          lineFields[13].fields.value !==
          officePhoneFieldValues.pricingAndOffers.sixTwelveMonthPromo
        ){
          lineFields[10].fields.hidden = true;
        lineFields[11].fields.hidden = true;
        lineFields[11].fields.value = '';
        lineFields[12].fields.readonly = true;
      }
      if (value === officePhoneFieldValues.regularOffer.standard) {
        lineFields[12].fields.readonly = false;
      }
    } else if (name.includes(fieldOfficePhoneTwoMonthsFree)) {
      if (value === officePhoneFieldValues.twoMonthsDuration.yes) {
        lineFields[12].fields.readonly = true;
      } else {
        lineFields[12].fields.readonly = false;
      }
    } else if (name.includes(fieldOfficePhonelimitedTimeOffer)) {
      if (value.length) {
        lineFields[9].fields.readonly = true;
      } else {
        lineFields[9].fields.readonly = false;
      }
    } else if (name.includes(fieldOfficePhonePricingAndOffers)) {
      if (
        value === officePhoneFieldValues.pricingAndOffers.sixTwelveMonthPromo
      ) {
        lineFields[13].fields.note = fieldPricingAndOffersNote;
        lineFields[10].fields.hidden = false;
      } else {
        delete lineFields[13].fields.note;
        if (
          lineFields[9].fields.value !==
          officePhoneFieldValues.regularOffer.sixTwelveMonth &&
          lineFields[9].fields.value !==
          officePhoneFieldValues.regularOffer.sixTwelveMonthBackPocket
        )
          lineFields[10].fields.hidden = true;
        lineFields[10].fields.value = '';
      }
    } else if (name.includes(fieldOfficeLineDesignation)) {
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < fieldRow.ovLines.length; i++) {
        if (fieldRow.ovLines[i].fields[3].fields.name === fieldOfficeLineDesignation) {
          fieldRow.ovLines[i].fields[3].fields.value = value;
          fieldRow.ovLines[i].fields[3].fields.error = '';
        }
      }
    }

    if (isOrderOfficePhone) {
      // manage order office phone fields
      const termFieldValue = lineFields[8].fields.value;
      const setupFieldValue = lineFields[3].fields.value;
      const contractBuyoutValue = lineFields[15].fields.value;
      if (name.includes(fieldOfficePhoneSetup)) {
        lineFields = processContractBuyoutFields(
          value,
          termFieldValue,
          contractBuyoutValue,
          lineFields
        );
      } else if (name.includes(fieldOfficePhoneTerm)) {
        lineFields = processContractBuyoutFields(
          setupFieldValue,
          value,
          contractBuyoutValue,
          lineFields
        );
      } else if (name.includes(fieldOfficePhoneContractBuyout)) {
        lineFields = processContractBuyoutFields(
          setupFieldValue,
          termFieldValue,
          value,
          lineFields
        );
      }
    }
    setFieldRows([...fieldRows]);
    setFormTouched(true);
  };

  const onFormValidate = () => {
    let hasErrors = false;
    fieldRows.forEach(mainRow => {
      mainRow.fields.forEach(fieldParam => {
        const field = fieldParam;
        if (
          field.fields.required &&
          !field.fields.disabled &&
          !field.fields.readonly &&
          !field.fields.hidden &&
          !field.fields.value
        ) {
          field.fields.error = fieldRequiredText;
          hasErrors = true;
        }
        if (phoneSetupNew !== 'new' && phoneCountNumber === 'lessThan10') {
          hasErrors = true
        }
      });

      if (mainRow.ovLines && mainRow.ovLines.length) {
        mainRow.ovLines.forEach(ovLine => {
          ovLine.fields.forEach(fieldParam => {
            const field = fieldParam;
            if (
              field.fields.required &&
              !field.fields.disabled &&
              !field.fields.readonly &&
              !field.fields.hidden &&
              !field.fields.value
            ) {
              field.fields.error = fieldRequiredText;
              hasErrors = true;
            }
          });
        });
      }
    });
    setFieldRows(lodash.cloneDeep(fieldRows));
    if (
      (networkType.data && networkType.data.length === 0) ||
      !networkType.data
    ) {
      setNetworkType({ data: networkType.data, error: fieldRequiredText });
      hasErrors = true;
    }
    return hasErrors;
  };

  const onFormSubmit = e => {
    e.preventDefault();
    const isValid = !onFormValidate();
    if (isValid) {
      const [fieldRow] = fieldRows;
      const mappedValues = { ovLines: [], key: uuidv4() };
      fieldRow.fields.forEach(field => {
        if (field.fields.value && !field.fields.hidden) {
          mappedValues[field.fields.name] = {
            label: field.fields.label,
            value: field.fields.value
          };
        }
      });
      mappedValues['networkType'] = {
        label: 'Network Type',
        value: networkType.data
      };
      fieldRow.ovLines.forEach((ovLine, ovLineIndex) => {
        if (!mappedValues.ovLines[ovLineIndex]) {
          mappedValues.ovLines[ovLineIndex] = {
            key: uuidv4()
          };
        }
        ovLine.fields.forEach(field => {
          if (field.fields.value && !field.fields.hidden)
            mappedValues.ovLines[ovLineIndex][field.fields.name] = {
              label: field.fields.label,
              value: field.fields.value
            };
        });
      });
      addedItems.push(mappedValues);
      if (addedItems.length) {
        setOfficePhoneRequired(false);
        let monthlyDue = dueMonthly > 0 ? dueMonthly : 0;
        const officePhoneItems = mappedValues;
        if (
          forbearanceFieldValue === officePhoneFieldValues.forbearance.forborne
        ) {
          monthlyDue +=
            pricing[officePhoneItems.ratePlan.value][
            officePhoneItems.term.value
            ];
            if (officePhoneItems && officePhoneItems.tollFree && officePhoneItems.tollFree.value === yes && officePhoneItems.ratePlan.value === opBasic) {
              monthlyDue += tollFreePrice;
            }
          if (officePhoneItems.regularOfferOfficePhone)
            monthlyDue +=
              pricing[officePhoneItems.ratePlan.value][
              officePhoneItems.regularOfferOfficePhone.value
              ];
          if (
            officePhoneItems.twoMonthsDuration &&
            officePhoneItems.twoMonthsDuration.value === 'Yes'
          ) {
            monthlyDue -=
              pricing[officePhoneItems.ratePlan.value][
              officePhoneItems.term.value
              ];
            if (officePhoneItems.regularOfferOfficePhone)
              monthlyDue -=
                pricing[officePhoneItems.ratePlan.value][
                officePhoneItems.regularOfferOfficePhone.value
                ];
          } else if (officePhoneItems.limitedTimeOfferOfficePhone) {
            monthlyDue -=
              pricing[officePhoneItems.ratePlan.value][
              officePhoneItems.term.value
              ];
            if (officePhoneItems.regularOfferOfficePhone)
              monthlyDue -=
                pricing[officePhoneItems.ratePlan.value][
                officePhoneItems.regularOfferOfficePhone.value
                ];           
          } 
        }else {
          monthlyDue +=
            pricingNonForborne[officePhoneItems.ratePlan.value].price;
            if (officePhoneItems && officePhoneItems.tollFree && officePhoneItems.tollFree.value === yes && officePhoneItems.ratePlan.value === opBasic) {
              monthlyDue += tollFreePrice;
            }
            if (officePhoneItems.pricingAndOffers) {
            monthlyDue +=
              pricingNonForborne[officePhoneItems.ratePlan.value][
              officePhoneItems.pricingAndOffers.value
              ];
          }
          if (
            officePhoneItems.twoMonthsDuration &&
            officePhoneItems.twoMonthsDuration.value === 'Yes'
          ) {
            monthlyDue -=
              pricing[officePhoneItems.ratePlan.value][
              officePhoneItems.term.value
              ];
            if (officePhoneItems.regularOfferOfficePhone)
              monthlyDue -=
                pricing[officePhoneItems.ratePlan.value][
                officePhoneItems.regularOfferOfficePhone.value
                ];
          } else if (officePhoneItems.limitedTimeOfferOfficePhone) {
            monthlyDue -=
              pricing[officePhoneItems.ratePlan.value][
              officePhoneItems.term.value
              ];
            if (officePhoneItems.regularOfferOfficePhone)
              monthlyDue -=
                pricing[officePhoneItems.ratePlan.value][
                officePhoneItems.regularOfferOfficePhone.value
                ];
          }
        }

        if (
          officePhoneItems.longDistanceAddOns &&
          officePhoneItems.longDistanceAddOns.value
        ) {
          monthlyDue +=
            longDistanceAddOns[officePhoneItems.longDistanceAddOns.value];
        }

        officePhoneItems.ovLines.forEach(officePhoneItemOvLine => {
          
          if (
            officePhoneItemOvLine.longDistanceAddOns &&
            officePhoneItemOvLine.longDistanceAddOns.value
          ) {
            monthlyDue +=
              longDistanceAddOns[officePhoneItemOvLine.longDistanceAddOns.value];
          }

          if (
            forbearanceFieldValue ===
            officePhoneFieldValues.forbearance.forborne
          ) {
            if (officePhoneItemOvLine.term) {
              monthlyDue +=
                pricing[officePhoneItemOvLine.ratePlan.value][
                officePhoneItemOvLine.term.value
                ];
                if (officePhoneItemOvLine && officePhoneItemOvLine.tollFree && officePhoneItemOvLine.tollFree.value === yes && officePhoneItemOvLine.ratePlan.value === opBasic) {
                  monthlyDue += tollFreePrice;
                }
              if (officePhoneItemOvLine.regularOfferOfficePhone)
                monthlyDue +=
                  pricing[officePhoneItemOvLine.ratePlan.value][
                  officePhoneItemOvLine.regularOfferOfficePhone.value
                  ];
              if (
                officePhoneItemOvLine.twoMonthsDuration &&
                officePhoneItemOvLine.twoMonthsDuration.value === 'Yes'
              ) {
                monthlyDue -=
                  pricing[officePhoneItemOvLine.ratePlan.value][
                  officePhoneItemOvLine.term.value
                  ];
                if (officePhoneItemOvLine.regularOfferOfficePhone)
                  monthlyDue -=
                    pricing[officePhoneItemOvLine.ratePlan.value][
                    officePhoneItemOvLine.regularOfferOfficePhone.value
                    ];
              } else if (officePhoneItemOvLine.limitedTimeOfferOfficePhone) {
                monthlyDue -=
                  pricing[officePhoneItemOvLine.ratePlan.value][
                  officePhoneItemOvLine.term.value
                  ];
                if (officePhoneItemOvLine.regularOfferOfficePhone)
                  monthlyDue -=
                    pricing[officePhoneItemOvLine.ratePlan.value][
                    officePhoneItemOvLine.regularOfferOfficePhone.value
                    ];
              }
            }
          } else {
            monthlyDue +=
              pricingNonForborne[officePhoneItemOvLine.ratePlan.value].price;
              if (officePhoneItemOvLine && officePhoneItemOvLine.tollFree && officePhoneItemOvLine.tollFree.value === yes && officePhoneItemOvLine.ratePlan.value === opBasic) {
                monthlyDue += tollFreePrice;
              }
              if (officePhoneItemOvLine.pricingAndOffers) {
              monthlyDue +=
                pricingNonForborne[officePhoneItemOvLine.ratePlan.value][
                officePhoneItemOvLine.pricingAndOffers.value
                ];
            }
            if (
              officePhoneItemOvLine.twoMonthsDuration &&
              officePhoneItemOvLine.twoMonthsDuration.value === 'Yes'
            ) {
              if (officePhoneItemOvLine.term) {
                monthlyDue -=
                  pricingNonForborne[officePhoneItemOvLine.ratePlan.value][
                  officePhoneItemOvLine.term.value
                  ];
              }
              if (officePhoneItemOvLine.regularOfferOfficePhone)
                monthlyDue -=
                  pricingNonForborne[officePhoneItemOvLine.ratePlan.value][
                  officePhoneItemOvLine.regularOfferOfficePhone.value
                  ];
            } else if (officePhoneItemOvLine.limitedTimeOfferOfficePhone && officePhoneItemOvLine.term) {
              monthlyDue -=
                pricingNonForborne[officePhoneItemOvLine.ratePlan.value][
                officePhoneItemOvLine.term.value
                ];
              if (officePhoneItemOvLine.regularOfferOfficePhone)
                monthlyDue -=
                  pricingNonForborne[officePhoneItemOvLine.ratePlan.value][
                  officePhoneItemOvLine.regularOfferOfficePhone.value
                  ];
            }
          }
        });
        setDueMonthly(monthlyDue);
        setIsFormTouched(true);
      }
      setAddedItems([...addedItems]);
      setFormFields({ ...formFields, officePhoneData: [...addedItems] });
      setFieldRows(initialForm);
      setNetworkType({});
    }
  };

  const addOvLine = () => {
    const [fieldRow] = fieldRows;
    const rowFields = fieldRow.fields;
    const [, ...otherFields] = lodash.cloneDeep(restFields);
    delete otherFields[10].fields.note;
    const typeFieldCopy = lodash.cloneDeep(typeField);
    const planFieldCopy = rowFields[1];
    const newFields = [
      {
        ...typeFieldCopy,
        fields: {
          ...typeFieldCopy.fields,
          disabled: true,
          options: [typeFieldOptions[2]],
          value: officePhoneFieldValues.type.ovLine
        }
      },
      planFieldCopy,
      ...otherFields
    ];

    const [, , , lineDesignationFld, , callingFeaturesFld] = rowFields;
    /**
     * Always copy lineDesignation value from previous (above) ovLines added.
     */
    newFields[3] = lodash.cloneDeep(lineDesignationFld); // copy line designation form above row
    newFields[5] = callingFeaturesFld; // copy calling features fromo above row
    newFields.forEach((data, index) => {
      if (data.fields.name === tollFree) {
        newFields[index].fields.hidden = true;
      }
    });
    fieldRow.ovLines.push({
      key: uuidv4(),
      fields: newFields
    });
    setFieldRows([...fieldRows]);
  };

  const deleteOvLine = index => {
    const [fieldRow] = fieldRows;
    fieldRow.ovLines.splice(index, 1);
    setFieldRows([...fieldRows]);
  };

  const onAddedItemDelete = addedItemIndex => {
    const orderDataFields = orderData;
    const addedItem = addedItems[addedItemIndex];
    let monthlyDue = dueMonthly;
    let currentDue = 0;
    if (addedItem[fieldForbearance].value === officePhoneFieldValues.forbearance.forborne) {
      if (addedItem && addedItem.tollFree && addedItem.tollFree.value === yes && addedItem.ratePlan.value === opBasic) {
        currentDue += tollFreePrice;
      }
      currentDue += pricing[addedItem.ratePlan.value][addedItem.term.value];
      if (addedItem.regularOfferOfficePhone)
        currentDue +=
          pricing[addedItem.ratePlan.value][
          addedItem.regularOfferOfficePhone.value
          ];
      if (
        addedItem.twoMonthsDuration &&
        addedItem.twoMonthsDuration.value === 'Yes'
      ) {
        currentDue -= pricing[addedItem.ratePlan.value][addedItem.term.value];
        if (addedItem.regularOfferOfficePhone)
          currentDue -=
            pricing[addedItem.ratePlan.value][
            addedItem.regularOfferOfficePhone.value
            ];
      } else if (addedItem.limitedTimeOfferOfficePhone) {
        currentDue -= pricing[addedItem.ratePlan.value][addedItem.term.value];
        if (addedItem.regularOfferOfficePhone)
          currentDue -=
            pricing[addedItem.ratePlan.value][
            addedItem.regularOfferOfficePhone.value
            ];
      }
    } else {
      currentDue += pricingNonForborne[addedItem.ratePlan.value].price;
      if (addedItem && addedItem.tollFree && addedItem.tollFree.value === yes && addedItem.ratePlan.value === opBasic) {
        currentDue += tollFreePrice;
      }
      if (addedItem.pricingAndOffers) {
        currentDue +=
          pricingNonForborne[addedItem.ratePlan.value][
          addedItem.pricingAndOffers.value
          ];
      }
      if (
        addedItem.twoMonthsDuration &&
        addedItem.twoMonthsDuration.value === 'Yes'
      ) {
        currentDue -=
          pricingNonForborne[addedItem.ratePlan.value][addedItem.term.value];
        if (addedItem.regularOfferOfficePhone)
          currentDue -=
            pricingNonForborne[addedItem.ratePlan.value][
            addedItem.regularOfferOfficePhone.value
            ];
      } else if (addedItem.limitedTimeOfferOfficePhone) {
        currentDue -=
          pricingNonForborne[addedItem.ratePlan.value][addedItem.term.value];
        if (addedItem.regularOfferOfficePhone)
          currentDue -=
            pricingNonForborne[addedItem.ratePlan.value][
            addedItem.regularOfferOfficePhone.value
            ];
      }
    }
    if (
      addedItem.longDistanceAddOns &&
      addedItem.longDistanceAddOns.value
    ) {
      monthlyDue -=
        longDistanceAddOns[addedItem.longDistanceAddOns.value];
    }
    addedItem.ovLines.forEach(officePhoneItemOvLine => {

      if (
        officePhoneItemOvLine.longDistanceAddOns &&
        officePhoneItemOvLine.longDistanceAddOns.value
      ) {
        monthlyDue -=
          longDistanceAddOns[officePhoneItemOvLine.longDistanceAddOns.value];
      }

      if (
        forbearanceFieldValue === officePhoneFieldValues.forbearance.forborne
      ) {
        currentDue +=
          pricing[officePhoneItemOvLine.ratePlan.value][
          officePhoneItemOvLine.term.value
          ];
          if (officePhoneItemOvLine && officePhoneItemOvLine.tollFree && officePhoneItemOvLine.tollFree.value === yes && officePhoneItemOvLine.ratePlan.value === opBasic) {
            monthlyDue -= tollFreePrice;
          }
        if (officePhoneItemOvLine.regularOfferOfficePhone)
          currentDue +=
            pricing[officePhoneItemOvLine.ratePlan.value][
            officePhoneItemOvLine.regularOfferOfficePhone.value
            ];
        if (
          officePhoneItemOvLine.twoMonthsDuration &&
          officePhoneItemOvLine.twoMonthsDuration.value === 'Yes'
        ) {
          currentDue -=
            pricing[officePhoneItemOvLine.ratePlan.value][
            officePhoneItemOvLine.term.value
            ];
          if (officePhoneItemOvLine.regularOfferOfficePhone)
            currentDue -=
              pricing[officePhoneItemOvLine.ratePlan.value][
              officePhoneItemOvLine.regularOfferOfficePhone.value
              ];
        } else if (officePhoneItemOvLine.limitedTimeOfferOfficePhone) {
          currentDue -=
            pricing[officePhoneItemOvLine.ratePlan.value][
            officePhoneItemOvLine.term.value
            ];
          if (officePhoneItemOvLine.regularOfferOfficePhone)
            currentDue -=
              pricing[officePhoneItemOvLine.ratePlan.value][
              officePhoneItemOvLine.regularOfferOfficePhone.value
              ];
        }
      } else {
        currentDue +=
          pricingNonForborne[officePhoneItemOvLine.ratePlan.value].price;
          if (officePhoneItemOvLine && officePhoneItemOvLine.tollFree && officePhoneItemOvLine.tollFree.value === yes && officePhoneItemOvLine.ratePlan.value === opBasic) {
            monthlyDue -= tollFreePrice;
          }
          if (officePhoneItemOvLine.pricingAndOffers) {
          currentDue +=
            pricingNonForborne[officePhoneItemOvLine.ratePlan.value][
            officePhoneItemOvLine.pricingAndOffers.value
            ];
        }
        if (
          officePhoneItemOvLine.twoMonthsDuration &&
          officePhoneItemOvLine.twoMonthsDuration.value === 'Yes'
        ) {
          currentDue -=
            pricingNonForborne[officePhoneItemOvLine.ratePlan.value][
            officePhoneItemOvLine.term.value
            ];
          if (officePhoneItemOvLine.regularOfferOfficePhone)
            currentDue -=
              pricingNonForborne[officePhoneItemOvLine.ratePlan.value][
              officePhoneItemOvLine.regularOfferOfficePhone.value
              ];
        } else if (officePhoneItemOvLine.limitedTimeOfferOfficePhone) {
          currentDue -=
            pricingNonForborne[officePhoneItemOvLine.ratePlan.value][
            officePhoneItemOvLine.term.value
            ];
          if (officePhoneItemOvLine.regularOfferOfficePhone)
            currentDue -=
              pricingNonForborne[officePhoneItemOvLine.ratePlan.value][
              officePhoneItemOvLine.regularOfferOfficePhone.value
              ];
        }
      }
    });
    monthlyDue -= currentDue;
    setDueMonthly(monthlyDue);

    addedItems.splice(addedItemIndex, 1);
    if (!addedItems.length) {
      setOfficePhoneRequired(true);
      setIsFormTouched(false);
    } else {
      setOfficePhoneRequired(false);
      setIsFormTouched(true);
    }
    setAddedItems([...addedItems]);
    orderDataFields.officePhoneData = addedItems;
    setFormFields({ ...formFields, officePhoneData: [...addedItems] });
  };

  return (
    <>
      <FlexGrid>
        <AddForm
          fieldRows={fieldRows}
          onFormSubmit={onFormSubmit}
          onFieldChange={onFieldChange}
          formTouched={formTouched}
          deleteOvLine={deleteOvLine}
          addOvLine={addOvLine}
          networkType={networkType}
          setNetworkType={setNetworkType}
          setFormTouched={setFormTouched}
        />
      </FlexGrid>
      <AddedItemsList
        addedItems={addedItems}
        onAddedItemDelete={onAddedItemDelete}
      />
      <br />
    </>
  );
};

OfficePhone.propTypes = {
  isOrderOfficePhone: PropTypes.bool.isRequired,
  fields: PropTypes.objectOf(PropTypes.any).isRequired,
  formFields: PropTypes.objectOf(PropTypes.any).isRequired,
  setFormFields: PropTypes.func.isRequired,
  setDueMonthly: PropTypes.func.isRequired,
  dueMonthly: PropTypes.number.isRequired,
  orderData: PropTypes.objectOf(PropTypes.any).isRequired,
  setIsFormTouched: PropTypes.func.isRequired,
  isEditing: PropTypes.bool.isRequired,
  setOfficePhoneRequired: PropTypes.func.isRequired
};

export default OfficePhone;